/** Resizable columns: client-side only, no API. */
export const MIN_COLUMN_WIDTH = 40;
export const DEFAULT_COLUMN_WIDTH = 120;
export const RESIZE_SORT_SUPPRESS_MS = 200;

export const RESIZE_HANDLE_STYLE = {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '1px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginRight: '-5px',
    backgroundColor: '#c4c4c4',
    backgroundClip: 'content-box',
    cursor: 'col-resize',
    boxSizing: 'content-box',
};

export const HEADER_LABEL_STYLE = { minWidth: 0, lineHeight: '28px' };
export const HEADER_WRAPPER_STYLE = { minHeight: '28px', width: '100%' };
